import { render, staticRenderFns } from "./websiteTechnology.vue?vue&type=template&id=54448842&scoped=true&"
import script from "./websiteTechnology.vue?vue&type=script&lang=js&"
export * from "./websiteTechnology.vue?vue&type=script&lang=js&"
import style0 from "./websiteTechnology.vue?vue&type=style&index=0&id=54448842&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54448842",
  null
  
)

export default component.exports